import React from 'react';
import './App.css';

function App() {

  return (
    <div className="portal-container">
      <div className="portal-modal">
        {/* ส่วนโลโก้ */}
        <img 
          src="logo-text-right.png" 
          alt="Company Logo" 
          className="portal-logo" 
        />
        
        <div className="content">
          <h2 className="fw-bold">ระบบบสำหรับริการข้อมูล</h2>

          {/* ส่วนปุ่มกด */}
          <div className="button-group">
            <a 
              href="https://ms.pncc.ac.th/affairs" target="_blank" rel="noreferrer"
              className="btn-portal btn-outline"
            >
              ระบบกิจกรรมนักศึกษา
            </a>
            <a 
              href="https://ms.pncc.ac.th/obes" target="_blank" rel="noreferrer"
              className="btn-portal btn-outline"
            >
              ระบบจัดเก็บหลักสูตร
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
